<template>
  <div v-if="showTab" class="bottom-nav-box">
    <van-tabbar route active-color="#996EFF" inactive-color="#A0A4A8">
      <van-tabbar-item class="menu-box" replace to="/lib">
        <div class="nv-icon icon-lib nav-icon"></div>
        <div>Library</div>
      </van-tabbar-item>
      <van-tabbar-item class="menu-box" replace to="/discover">
        <div class="nv-icon icon-discover nav-icon"></div>
        <div>Discover</div>
      </van-tabbar-item>
      <van-tabbar-item class="menu-box" replace to="/me">
        <div class="nv-icon icon-me nav-icon"></div>
        <div>Me</div>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  computed: {
    showTab() {
      return !!this.$route.meta.showTab;
    }
  }
};
</script>

<style lang="scss" scoped>
.bottom-nav-box {
  .menu-box {
    text-align: center;
    .nav-icon {
      font-size: 20px;
    }
  }
}
</style>
